import { useToastStore } from '../store/toastStore';

export function Toaster() {
  const { toasts, removeToast } = useToastStore();
  if (toasts.length === 0) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 24, right: 24, zIndex: 9999,
      display: 'flex', flexDirection: 'column-reverse', gap: 8,
    }}>
      {toasts.map(t => {
        const bg = t.type === 'success' ? '#16a34a' : t.type === 'error' ? '#dc2626' : '#7c6ff7';
        const icon = t.type === 'success' ? '✓' : t.type === 'error' ? '✕' : 'ℹ';
        return (
          <div
            key={t.id}
            style={{
              background: bg, color: '#fff',
              padding: '11px 16px', borderRadius: 10, fontSize: 13, fontWeight: 500,
              boxShadow: '0 4px 24px rgba(0,0,0,0.35)',
              display: 'flex', alignItems: 'center', gap: 10, maxWidth: 400, minWidth: 240,
              animation: 'wizard-slide-fwd 0.2s ease',
            }}
          >
            <span style={{ fontSize: 15, flexShrink: 0 }}>{icon}</span>
            <span style={{ flex: 1, lineHeight: 1.4 }}>{t.message}</span>
            <button
              onClick={() => removeToast(t.id)}
              style={{
                background: 'none', border: 'none', color: 'rgba(255,255,255,0.7)',
                cursor: 'pointer', fontSize: 16, lineHeight: 1, padding: 0, flexShrink: 0,
              }}
            >✕</button>
          </div>
        );
      })}
    </div>
  );
}
